export default __webpack_public_path__ + "static/JarDwellers-square-94134676dddeb46e1e7a55692832e902.png";